import type { ProductGroup } from 'shared/products/groups/domain/productGroup';
import type { ProductType } from 'shared/products/domain/productType';

export interface ProductGroupFormValues {
  name: string;
  color: string;
  description: string;
  productType: ProductType;
}

// Maps a source group to the dialog's form values; copyName lets the copy path suffix the name.
export function buildProductGroupFormValues(
  source: ProductGroup,
  copyName: (name: string) => string,
): ProductGroupFormValues {
  return {
    name: copyName(source.name),
    color: source.color ?? '#3b82f6',
    description: source.description,
    productType: source.productType,
  };
}
